<template>
  <router-view v-bind="activeRoute"></router-view>
</template>

<script>
export default {
  name: "proyekrab",
  computed: {
    activeRoute() {
      return { route: this.$route.matched[0].meta[0] };
    }
  }
};
</script>

<style>
</style>